module.exports = __webpack_public_path__ + "img/emptystate-events.ee22997a.svg";